/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Transcript_CopiedInputs */



/**
* | output |
* | --- |
* | "Copied" |
*
* @param {Meeting_Transcript_CopiedInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_transcript_copied = /** @type {((inputs?: Meeting_Transcript_CopiedInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Transcript_CopiedInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Gekopieerd")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Copié")
	return /** @type {LocalizedString} */ ("Copied")
});